export default __webpack_public_path__ + "static/media/red-background-pattern.f6fc8391.svg";